(() => {
  const GIFT_CARD_VARIANT_ID = 49190049415382;

  function initializeGiftOption(container) {
    if (container.dataset.petalGiftReady === 'true') return;

    const checkbox = container.querySelector('[data-petal-gift-checkbox]');
    const messageWrapper = container.querySelector(
      '[data-petal-gift-message-wrapper]'
    );
    const messageField = container.querySelector('[data-petal-gift-message]');
    const productForm = container.nextElementSibling;

    if (!checkbox || !messageWrapper || !messageField || !productForm) return;

    container.dataset.petalGiftReady = 'true';

    checkbox.addEventListener('change', () => {
      messageWrapper.hidden = !checkbox.checked;

      if (!checkbox.checked) {
        messageField.value = '';
      }
    });

    productForm.addEventListener(
      'submit',
      async (event) => {
        if (!checkbox.checked) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const submitButton = productForm.querySelector('[type="submit"]');
        const variantInput = productForm.querySelector('[name="id"]');
        const quantityInput = productForm.querySelector('[name="quantity"]');

        const productVariantId = Number(variantInput?.value);
        const quantity = Number(quantityInput?.value || 1);
        const giftMessage = messageField.value.trim();

        if (!productVariantId) {
          alert('We could not add this product. Please refresh the page and try again.');
          return;
        }

        if (!giftMessage) {
          alert('Please enter your gift message.');
          messageField.focus();
          return;
        }

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.classList.add('loading');
        }

        try {
          const response = await fetch(
            `${window.Shopify.routes.root}cart/add.js`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                items: [
                  {
                    id: productVariantId,
                    quantity
                  },
                  {
                    id: GIFT_CARD_VARIANT_ID,
                    quantity: 1,
                    properties: {
                      'Gift message': giftMessage
                    }
                  }
                ]
              })
            }
          );

          if (!response.ok) {
            const error = await response.json();
            throw new Error(
              error.description || 'The items could not be added to your cart.'
            );
          }

          window.location.href = `${window.Shopify.routes.root}cart`;
        } catch (error) {
          console.error('Petal & Peel gift option error:', error);
          alert(error.message || 'Something went wrong. Please try again.');
        } finally {
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.classList.remove('loading');
          }
        }
      },
      true
    );
  }

  function initializeAllGiftOptions() {
    document
      .querySelectorAll('[data-petal-gift-option]')
      .forEach(initializeGiftOption);
  }

  document.addEventListener('DOMContentLoaded', initializeAllGiftOptions);
  document.addEventListener('shopify:section:load', initializeAllGiftOptions);
})();